import React, {Component} from 'react';
import {Glyphicon, Navbar} from 'react-bootstrap';
import {connect} from 'react-redux';
import {AuthTokenStorage, JWToken} from '../common/authTokenStorage';
import * as authActions from '../store/auth/authSlice';
import LogoutConfirmDialog from './logoutConfirmDialog';
import TooltipElement from '../components/tooltipElement';

class NavbarAuthManager extends Component {
  constructor() {
    super();
    this.onLogoutButtonClick = this.onLogoutButtonClick.bind(this);
    this.closeLogoutConfirmDialog = this.closeLogoutConfirmDialog.bind(this);
    this.state = {
      showLogoutConfirmDialog: false
    };
  }

  UNSAFE_componentWillMount() {
    if (!AuthTokenStorage.isAccessTokenDefined()) {
      return;
    }
    if (this.props.inSession) {
      return;
    }
    let ajwt = new JWToken(AuthTokenStorage.accessToken);
    if (!ajwt.parse()) {
      return;
    }
    this.props.loginSuccess({
      name: ajwt.login,
      allowWrite: ajwt.allowWrite,
    });
  }

  render() {
    if (!this.props.inSession) {
      return null;
    }
    return (
      <div>
        <Navbar.Text pullRight>
          {this.props.userName}
          <Navbar.Link href="#" onClick={e => this.onLogoutButtonClick(e)}>
            <TooltipElement.WithOverlay text="Logout">
              <Glyphicon glyph="log-out rightIcon"/>
            </TooltipElement.WithOverlay>
          </Navbar.Link>
        </Navbar.Text>
        <LogoutConfirmDialog
          show={this.state.showLogoutConfirmDialog}
          onClose={this.closeLogoutConfirmDialog}
        />
      </div>
    );
  }

  onLogoutButtonClick(e) {
    e.preventDefault();
    this.showLogoutConfirmDialog();
  }

  showLogoutConfirmDialog() {
    this.setState({showLogoutConfirmDialog: true});
  }

  closeLogoutConfirmDialog() {
    this.setState({showLogoutConfirmDialog: false});
  }
}

function mapStateToProps(state) {
  return {
    inSession: state.auth.inSession,
    userName: state.auth.userName,
    allowWrite: state.auth.allowWrite,
  };
}

const actionCreators = {
  logout: authActions.logout,
  loginSuccess: authActions.authLoginSuccess,
};

export default connect(mapStateToProps, actionCreators)(NavbarAuthManager);



// WEBPACK FOOTER //
// ./src/containers/authManager.js